import { z } from "zod";
import { RequestPartnerDtoSchema } from "./RequestPartnerDto";
import { RequestPoistkaDtoSchema } from "./RequestPoistkaDto";
import { RequestPartnerAddressDtoSchema } from "./RequestPartnerAddressDto";

export const RequestHelperGetPrepopInfoOutputSchema = z.object({
    contracts: z.array(RequestPoistkaDtoSchema),
    partner: RequestPartnerDtoSchema.nullish(),
    addresses: z.array(RequestPartnerAddressDtoSchema),
});

export type RequestHelperGetPrepopInfoOutput = z.infer<typeof RequestHelperGetPrepopInfoOutputSchema>;